<div>
  <h3 mat-dialog-title class="bg-white customization-head">
    @if (this.data.promotion) {
      Update {{ this.data.promotion.name }}
    } @else {
      Add New Promotion
    }
  </h3>

  <div class="sub-head pl-4">Provide basic details to add a new promotion.</div>

  <mat-dialog-content class="pt-3 pb-4">
    <form [formGroup]="promotionForm">
      <div class="d-flex flex-column mb-3 pt-2">
        <div class="row">
          <div class="col-4">
            <label class="form-label pl-0">
              <span class="status-span">*</span>Promotion Name:
            </label>
            <input
              type="text"
              formControlName="promotionName"
              class="form-control"
              placeholder="Eg: Enter promotion"
            />
            @if (
              promotionForm.get('promotionName')?.errors?.['required'] &&
              (promotionForm.get('promotionName')?.dirty ||
                promotionForm.get('promotionName')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Promotion Name cannot be empty.</p>
              </div>
            }
            @if (
              promotionForm.get('promotionName')?.hasError('duplicateName') &&
              (promotionForm.get('promotionName')?.dirty ||
                promotionForm.get('promotionName')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Promotion Name cannot be duplicate.</p>
              </div>
            }
          </div>
          <div class="col-4">
            <label class="form-label pl-0"> <span class="status-span">*</span>Type: </label>
            <!-- <input type="text" class="form-control" placeholder="Eg: Promotion1" > -->
            <select class="form-select" formControlName="type">
              <option value="0" selected disabled>Select Type</option>
              <option value="percentage">Percentage Deal</option>
              <option value="fixed">Fixed Amount</option>
            </select>
            @if (
              promotionForm.get('type')?.errors?.['required'] &&
              (promotionForm.get('type')?.dirty || promotionForm.get('type')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Promotion Type can not be empty.</p>
              </div>
            }
          </div>
          <div class="col-4">
            <label class="form-label pl-0"> <span class="status-span">*</span>Discount: </label>
            <input
              type="number"
              formControlName="discount"
              class="form-control"
              id="promoDiscount"
              placeholder="Enter discount"
            />
            @if (
              promotionForm.get('discount')?.errors?.['required'] &&
              (promotionForm.get('discount')?.dirty || promotionForm.get('discount')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Discount can not be empty.</p>
              </div>
            }
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <label class="form-label pl-0"> <span class="status-span">*</span>Scope: </label>
            <select
              class="form-select"
              formControlName="scope"
              id="promoScope"
              (change)="onPromoScopeChange($event)"
            >
              <option selected disabled>Select Scope</option>
              <option value="category" disabled>Category</option>
              <option value="item" selected>Item</option>
            </select>
            @if (
              promotionForm.get('scope')?.errors?.['required'] &&
              (promotionForm.get('scope')?.dirty || promotionForm.get('scope')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Promotion scope can not be empty.</p>
              </div>
            }
          </div>
          <div class="col-6">
            <label class="form-label pl-0">
              <span class="status-span">*</span>{{ selectedScope | titlecase }}s:
            </label>
            <ng-multiselect-dropdown
              class="custome-ng-multiselect-dropdown"
              [placeholder]="'Select ' + selectedScope + 's'"
              [settings]="dropdownSettings"
              [data]="dropdownList"
              [(ngModel)]="selectedItems"
              formControlName="items"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
            >
            </ng-multiselect-dropdown>
            @if (
              promotionForm.get('items')?.errors?.['required'] &&
              promotionForm.get('items')?.touched
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Scope options can not be empty.</p>
              </div>
            }
          </div>
          <div class="col-6 d-none">
            <label class="form-label pl-0"> <span class="status-span">*</span>Items: </label>
            <input type="text" class="form-control" placeholder="Eg: Promotion1" />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <label class="form-label pl-0"> <span class="status-span">*</span>Start Date: </label>
            <input type="date" class="form-control" id="startDate" formControlName="startDate" />
            @if (
              promotionForm.get('startDate')?.errors?.['required'] &&
              (promotionForm.get('startDate')?.dirty || promotionForm.get('startDate')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Start date can not be empty.</p>
              </div>
            }
          </div>
          <div class="col-6">
            <label class="form-label pl-0"> <span class="status-span">*</span>End Date: </label>
            <input type="date" class="form-control" id="endDate" formControlName="endDate" />
            @if (
              promotionForm.get('endDate')?.errors?.['required'] &&
              (promotionForm.get('endDate')?.dirty || promotionForm.get('endDate')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>End date can not be empty.</p>
              </div>
            }
          </div>
          @if (promotionForm.hasError('invalidDateRange') && promotionForm.touched) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>{{ promotionForm.getError('invalidDateRange') }}</p>
            </div>
          }
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <label class="form-label pl-0"> <span class="status-span">*</span>Start Time: </label>
            <input type="time" class="form-control" id="startTime" formControlName="startTime" />
            @if (
              promotionForm.get('startTime')?.errors?.['required'] &&
              (promotionForm.get('startTime')?.dirty || promotionForm.get('startTime')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Start time can not be empty.</p>
              </div>
            }
          </div>
          <div class="col-6">
            <label class="form-label pl-0"> <span class="status-span">*</span>End Time: </label>
            <input type="time" class="form-control" id="endTime" formControlName="endTime" />
            @if (
              promotionForm.get('endTime')?.errors?.['required'] &&
              (promotionForm.get('endTime')?.dirty || promotionForm.get('endTime')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>End time can not be empty.</p>
              </div>
            }
          </div>
          @if (promotionForm.hasError('invalidTimeRange') && promotionForm.touched) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>{{ promotionForm.getError('invalidTimeRange') }}</p>
            </div>
          }
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <label class="form-label pl-0"> <span class="status-span">*</span>Active days: </label>
            <div>
              @for (d of dayList; track d; let z = $index) {
                <input
                  type="checkbox"
                  class="btn-check"
                  [name]="d.day"
                  [id]="d.day"
                  [value]="d.day"
                  [checked]="d.isChecked"
                  (click)="selectDay(d, $event)"
                  autocomplete="off"
                />
                <label class="btn btn-light m-2" [for]="d.day">
                  {{ d.day }}
                </label>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <!-- Actions Section -->
  <mat-dialog-actions class="justify-content-end gap-3 border-top pt-3 pb-3 pr-4">
    <button class="btn btn-light" mat-dialog-close>Cancel</button>
    @if (this.data.promotion) {
      <button
        type="button"
        class="btn btn-dark"
        (click)="addNewPromotion()"
        [disabled]="promotionForm.invalid"
      >
        Update
      </button>
    } @else {
      <button
        type="button"
        class="btn btn-dark"
        (click)="addNewPromotion()"
        [disabled]="promotionForm.invalid"
      >
        Add New Promotion
      </button>
    }
  </mat-dialog-actions>
</div>
